

<div class="carousel-container" [ngClass]="[themeType , defaultPosition]">
    <div class="carousel-slide" *ngFor="let slide of slides; let i = index" 
    [ngClass]="{'active': i === currentSlide, 'slide-in-right' : i === currentSlide && animationDirection === 'right', 'slide-in-left' : i === currentSlide && animationDirection === 'left' 
}"
    >
        <img [src]="slide.image"
              (load)="onImageLoad(i)"
           (error)="onImageError(i)" loading="lazy" decoding="async" *ngIf="!slide?.error" />
        <div class="custom-data-block-content">
            <div [ngClass]="[slide.theme, slide.position]" class="custom-data-block">
                <h1 class="carousel-title" *ngIf="slide.title">
                    {{slide.title}}
                </h1>
                <div class="description" *ngIf="slide?.safeHTML" [innerHTML]="slide?.safeHTML"></div>
                <button (click)="onButtonClick(slide.button)" class="techops-global-button carousel-btn" *ngIf="slide?.button">{{slide?.button?.split(';')[0] ? slide?.button?.split(';')[0] : ''}}</button>
            </div>
        </div>  
    </div>
    <button *ngIf="carouselConfig?.showNavigationArrows" [ngClass]="themeType" class="nav prev" (click)="prevSlide()">
    </button>
    <button *ngIf="carouselConfig?.showNavigationArrows" [ngClass]="themeType" class="nav next" (click)="nextSlide()">
    </button>
    <button [ngClass]="themeType" class="play-pause-btn" mat-icon-btn (click)="onPlayPauseButton()">
        <mat-icon *ngIf="isCarousePaused">play_arrow</mat-icon>
        <mat-icon *ngIf="!isCarousePaused">pause</mat-icon>
    </button>
    <div class="indicators" [ngClass]="themeType" *ngIf="carouselConfig?.showNavigationIndicators">
        <span *ngFor="let slide of slides; let i = index" [ngClass]="{'active': i === currentSlide}"
            (click)="goToSlide(i)"></span>
    </div>
</div>